import EDCollapse from '../Collapsables/Collapse/EDCollapse';
import { ITreeSelectProps } from './EDTreeSelect';
import EDTreeSelectListItem from './EDTreeSelectListItem';
import { makeStyles } from 'tss-react/mui';
import { ITreeSection } from './TreeSelectUtils';

interface IProps<T> extends ITreeSelectProps<T> {
  section: ITreeSection;
  sectionIndex: number;
  suggestionIndex?: number;
  suggestion: ITreeSection;
  level: number;
}

const useStyles = makeStyles()(theme => ({
  container: {
    paddingLeft: theme.spacing(2),
  },
  nodeLine: {
    borderLeft: `2px solid #d7d7d7`,
  },
}));

function EDTreeSelectNestedListItem<T>(props: IProps<T>) {
  const { classes, cx } = useStyles();
  const baseCase = props.section.value.split('|').length === 1;
  const section: ITreeSection = {
    ...props.suggestion,
    value: `${baseCase ? props.sectionIndex : props.section.value}|subList|${
      props.suggestionIndex
    }`,
  };

  return (
    <EDCollapse
      unmountOnExit
      mountOnEnter
      open={Boolean(props.suggestion.open)}
    >
      <div
        className={cx(classes.container, {
          [classes.nodeLine]:
            !!props.showSubSectionLines &&
            ((typeof props.showSubSectionLines === 'boolean' &&
              props.showSubSectionLines) ||
              props.level <= props.showSubSectionLines),
        })}
      >
        <EDTreeSelectListItem
          {...props}
          section={section}
          selections={section.subList ?? []}
          sectionIndex={props.section.subList?.indexOf(props.suggestion) ?? 0}
          level={props.level + 1}
        />
      </div>
    </EDCollapse>
  );
}

export default EDTreeSelectNestedListItem;
